import {useState} from "react";
import "../../../framework/style/Form.css"
import "../../../framework/style/QuestionsStyles.css"
import AffiliatesQuestion from "./question/common/AffiliatesQuestion";
import ThirdPartyProcessorQuestion from "./question/common/ThirdPartyProcessorQuestion";
import PublicCodeUsageQuestion from "./question/collaborator/PublicCodeUsageQuestion";
import PapersPublishedQuestion from "./question/common/PapersPublishedQuestion";
import CodeReferencesQuestion from "./question/common/CodeReferencesQuestion";
import ProjectInstitute from "../model/ProjectInstitute";
import {NavLink} from "react-router-dom";

/**
 * An interface to represent the project institute for this report
 */
interface CollaboratorAnnualReportFormProps {
   projectInstitute: ProjectInstitute;
   isSaving: boolean;
   handleSubmit: Function;
}

const CONFIRMATION1 = `I am the Lead Collaborator at the Collaborator Institute and of the Research Project identified above.`;
const CONFIRMATION2 = `The research conducted by the Collaborator Institute is within the parameters of the Research 
                  Project’s approved scope and the progress of the research is consistent with the Applicant PI’s project update.`;
const CONFIRMATION3 = `This project is compliant with the provisions of the relevant Material Transfer Agreement(s) 
                  (including any applicable amendments and updates) and associated Annexes`;
const CONFIRMATION4 = `I have disclosed the details of all open-source code repositories (e.g. GitHub) associated with 
                  this research project. I have read and understood the guidance on the use of code repositories, and I 
                  understand that any misuse of data could result in UK Biobank terminating access to data for this 
                  project`;

/**
 * Collaborator annual report form.
 */
export default function CollaboratorAnnualReportForm({
                                                        projectInstitute,
                                                        isSaving,
                                                        handleSubmit
                                                     }: CollaboratorAnnualReportFormProps) {
   const [confirmation1, setConfirmation1] = useState(false);
   const [confirmation2, setConfirmation2] = useState(false);
   const [confirmation3, setConfirmation3] = useState(false);
   const [confirmation4, setConfirmation4] = useState(false);

   return (
      <form id="collabAnnualReport" className="needs-validation"
            onSubmit={(e) => handleSubmit(e, projectInstitute.form)}>
         {/*Question area of the form*/}
         <div id="collabAnnualReportQuestionArea" className="form-question-area">
            {!projectInstitute.isAcademic &&
               <AffiliatesQuestion isLocked={projectInstitute.form.locked} form={projectInstitute.form}/>}
            <ThirdPartyProcessorQuestion isLocked={projectInstitute.form.locked} form={projectInstitute.form}/>
            <PublicCodeUsageQuestion isLocked={projectInstitute.form.locked} form={projectInstitute.form}/>
            <PapersPublishedQuestion isLocked={projectInstitute.form.locked} form={projectInstitute.form}/>
            <CodeReferencesQuestion form={projectInstitute.form} isLocked={projectInstitute.form.locked}/>
         </div>
         {/*Confirmation area of the form*/}
         <div id="collabAnnualReportConfirmationArea" className="form-confirmation-area">
            {(!projectInstitute.form.locked) ? <>
                  <div id="collabAnnualReportConfirmation1" className="form-check">
                     <input id="collabAnnualReportConfirmation1Check" className="form-check-input" type="checkbox"
                            value=""
                            onChange={() => setConfirmation1(!confirmation1)}/>
                     <label id="collabAnnualReportConfirmation1Label" className="form-check-label"
                            htmlFor="collabAnnualReportConfirmation1Check">
                        {CONFIRMATION1}
                     </label>
                  </div>
                  <div id="collabAnnualReportConfirmation2" className="form-check">
                     <input id="collabAnnualReportConfirmation2Check" className="form-check-input" type="checkbox"
                            value=""
                            onChange={() => setConfirmation2(!confirmation2)}/>
                     <label id="collabAnnualReportConfirmation2Label" className="form-check-label"
                            htmlFor="collabAnnualReportConfirmation2Check">
                        {CONFIRMATION2}
                     </label>
                  </div>
                  <div id="collabAnnualReportConfirmation3" className="form-check">
                     <input id="collabAnnualReportConfirmation3Check" className="form-check-input" type="checkbox"
                            value=""
                            onChange={() => setConfirmation3(!confirmation3)}/>
                     <label id="collabAnnualReportConfirmation3Label" className="form-check-label"
                            htmlFor="collabAnnualReportConfirmation3Check">
                        {CONFIRMATION3}
                     </label>
                  </div>
                  <div id="collabAnnualReportConfirmation4" className="form-check">
                     <input id="collabAnnualReportConfirmation4Check" className="form-check-input" type="checkbox"
                            value=""
                            onChange={() => setConfirmation4(!confirmation4)}/>
                     <label id="collabAnnualReportConfirmation4Label" className="form-check-label"
                            htmlFor="collabAnnualReportConfirmation4Check">
                        {CONFIRMATION4}
                     </label>
                  </div>
                  <div id="collabAnnualReportSaveArea" className="form-save-area">
                     <button id="collabAnnualReportSubmitBtn" type="submit" className="btn btn-success"
                             formNoValidate
                             disabled={!confirmation1 || !confirmation2 || !confirmation3 || !confirmation4 || isSaving}
                     >Submit
                     </button>
                     <button id="collabAnnualReportSaveBtn" type="submit" className="btn btn-primary"
                             formNoValidate disabled={isSaving}>Save
                        Draft
                     </button>
                  </div>
               </>
               :
               <div id="collabAnnualReportSaveArea" className="form-save-area">
                  <button id="collabAnnualReportUnlockBtn" type="submit" className="btn btn-success"
                          formNoValidate disabled={isSaving}>
                     Unlock Report
                  </button>
                  <button id="collabAnnualReportApproveBtn" type="submit" className="btn btn-primary"
                          formNoValidate disabled={isSaving}>
                     Approve Report
                  </button>
               </div>}
            <NavLink to="?page=annual-report" className="nav-link return-to-landing">
               <i className="bi bi-arrow-left-short"></i>Return to Annual Reports
            </NavLink>
         </div>
      </form>
   );
}
